/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from "react-overlay-loader";
import maleAvatar from "../../assets/images/Male-Avatar.png";
import computerIcon from '../../assets/images/computer-icon-hover.png';
import alertsIcon from '../../assets/images/alerts-icon.png';
import * as actions from "../../store/actions";
import {timezones} from "./timezones";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";

class Scheduler extends Component {
    state = {
        schedulers: this.props.schedulers || [],
        addScheduler: false,
        editScheduler: false,
        showDelete: false,
        deletedScheduler: null,
        editedSchedulerId: null,
        editedScheduler: null,
        show15mins: false,
    };

    componentDidMount() {
        window.$(function () {

            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            });

        });
    }

    componentWillMount() {
        this.props.onFetchSchedulers(this.props.token)
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            schedulers: props.schedulers
        });
    }

    isReadOnly = () => {

        if (this.props.permissions === null || this.props.permissions === undefined) {
            return false;
        }
        if (this.props.permissions.policies === null || this.props.permissions.policies === undefined) {
            return false;
        }
        //for now we only care about READONLY for all features
        if (this.props.permissions.policies.length === 0) {
            return false;
        }
        let p = this.props.permissions.policies[0];
        if (p.role === "ReadOnly" && p.feature === "All") {
            return true;
        }

        return false;
    };

    handleLogout = () => {
        this.props.onLogout(this.props.token)
    };

    redirectToDashboard = (e) => {
        e.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToGcpDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/gcpDashboard")
    };

    redirectToSettings = (e) => {
        e.preventDefault();
        this.props.history.push("/accountSettings")
    };

    redirectToInstallation = (e) => {
        e.preventDefault();
        this.props.history.push("/installation")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToBudget = (e) => {
        e.preventDefault();
        this.props.history.push("/budgets")
    };

    redirectToAlerts = (e) => {
        e.preventDefault();
        this.props.history.push("/alerts")
    }

    handleAddScheduler = (e) => {
        e.preventDefault();
        this.setState({
            addScheduler: true,
            editedScheduler: {},
            show15mins: false
        });

        this.startTimer();
    };

    startTimer = () => {
        setTimeout(() => {
            if (!this.state.editedScheduler) {
                this.startTimer()
            } else {
                let f = this.isReadOnly
                window.$(function () {
                    window.jcf.replaceAll();
                });
                window.$('.schedule-day').on('click', function() {
                    if (f()) {
                        return false;
                    }
                    window.$(this).closest('tr').toggleClass("booked");
                });

                window.$('.schedule-table tbody').on( 'click', 'td .data-status', function () {
                    if (f()) {
                        return false;
                    }
                    window.$(this).toggleClass('schedule-booked');
                });

                window.$(".schedule-table th").click(function(){
                    if(f()) {
                        return false;
                    }
                    var columnNo = window.$(this).index();
                    window.$(this).closest("table")
                        .find("tr td:nth-child(" + (columnNo+1) + ")")
                        .toggleClass('booked');
                });

                if (this.state.show15mins) {
                    if (this.state.addScheduler) {
                        this.show15minutesInit();
                    } else if(this.state.editScheduler) {
                        this.show15minuteseditInit();
                    }
                } else {
                    if (this.state.addScheduler) {
                        this.show1hourInit();
                    } else if (this.state.editScheduler) {
                        this.show1houreditInit();
                    }
                }
            }
        }, 10);
    };

    handleEditScheduler = (e, index) => {
        e.preventDefault();
        let s = this.state.schedulers[index];
        let show15mins = true;
        if (s.granularity === 'hour') {
            show15mins = false;
        }
        this.setState({editScheduler: true, editedScheduler: this.state.schedulers[index], editedSchedulerId: index, show15mins: show15mins});
        this.startTimer();
    };

    handleAddSchedulerSubmit = (e) => {
        e.preventDefault();
        let schedulers = [];

        if (this.state.show15mins) {
            window.$('div#div15minutes > .schedule-table tbody > tr').each((index, row) => {
                let rowBooked = window.$(row).hasClass('booked');

                schedulers[index] = [];
                window.$(row).children("td").filter((i) => i >= 1).each((idx, td) => {
                    let colBooked = window.$(td).hasClass('booked');
                    schedulers[index][idx] = [];

                    window.$(td).children('div').each((i, c) => {
                        if (rowBooked || colBooked || window.$(c).hasClass("schedule-booked")) {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: i* 15,
                                status: 'off'
                            })
                        } else {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: i* 15,
                                status: 'on'
                            })
                        }
                    })
                })
            });
        } else {
            window.$('div#div1hour > .schedule-table tbody > tr').each((index, row) => {
                let rowBooked = window.$(row).hasClass('booked');

                schedulers[index] = [];
                window.$(row).children("td").filter((i) => i >= 1).each((idx, td) => {
                    let colBooked = window.$(td).hasClass('booked');

                    schedulers[index][idx] = [];

                    window.$(td).children('div').each((i, c) => {
                        if (rowBooked || colBooked || window.$(c).hasClass("schedule-booked")) {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: 0,
                                status: 'off'
                            })
                        } else {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: 0,
                                status: 'on'
                            })
                        }
                    })

                })
            });
        }
        let granularity = "hour";
        if (this.state.show15mins) {
            granularity = "15min";
        }

        let current = {...this.state.editedScheduler, granularity: granularity, schedulers: schedulers};

        let allSchedulers = this.state.schedulers.concat(current);
        this.setState({schedulers: allSchedulers, editedScheduler: null, addScheduler: false, show15mins: false})
        this.props.onUpdateScheduler(this.props.token, allSchedulers)
    };

    handleEditSchedulerSubmit = (e) => {
        e.preventDefault();

        let schedulers = [];

        if (this.state.show15mins) {
            window.$('div#div15minutesedit > .schedule-table tbody > tr').each((index, row) => {
                let rowBooked = window.$(row).hasClass('booked');

                schedulers[index] = [];
                window.$(row).children("td").filter((i) => i >= 1).each((idx, td) => {
                    let colBooked = window.$(td).hasClass('booked');
                    schedulers[index][idx] = [];

                    window.$(td).children('div').each((i, c) => {
                        if (rowBooked || colBooked || window.$(c).hasClass("schedule-booked")) {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: i* 15,
                                status: 'off'
                            })
                        } else {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: i* 15,
                                status: 'on'
                            })
                        }
                    })
                })
            });
        } else {
            window.$('div#div1houredit > .schedule-table tbody > tr').each((index, row) => {
                let rowBooked = window.$(row).hasClass('booked');

                schedulers[index] = [];
                window.$(row).children("td").filter((i) => i >= 1).each((idx, td) => {
                    let colBooked = window.$(td).hasClass('booked');

                    schedulers[index][idx] = [];

                    window.$(td).children('div').each((i, c) => {
                        if (rowBooked || colBooked || window.$(c).hasClass("schedule-booked")) {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: 0,
                                status: 'off'
                            })
                        } else {
                            schedulers[index][idx].push({
                                weekDay: index,
                                hour: idx,
                                min: 0,
                                status: 'on'
                            })
                        }
                    })

                })
            });
        }

        let granularity = "hour";
        if (this.state.show15mins) {
            granularity = "15min";
        }

        let current = {...this.state.editedScheduler, granularity: granularity, schedulers: schedulers};

        let allSchedulers = [...this.state.schedulers.slice(0, this.state.editedSchedulerId), current, ...this.state.schedulers.slice(this.state.editedSchedulerId + 1)];
        this.setState({schedulers: allSchedulers, editedScheduler: null, editedSchedulerId: null, editScheduler: false, show15mins: false});
        this.props.onUpdateScheduler(this.props.token, allSchedulers)
    };


    handleDeleteScheduler = (e, index) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedScheduler: index})
    };

    handleCopyScheduler = (e, index) => {
        this.props.onCopyScheduler(this.props.token, this.state.schedulers[index].name)
    };

    toggleAddScheduler = () => {
        this.setState({addScheduler: !this.state.addScheduler})
    };

    toggleEditScheduler = () => {
        this.setState({editScheduler: !this.state.editScheduler})
    };

    toggleShowDelete = () => {
        this.setState({
            showDelete: !this.state.showDelete
        });
    };

    handleCancelDelete = () => {
        this.setState({showDelete: false, deletedScheduler: null})
    };

    handleDelete = e => {
        e.preventDefault();
        if (this.state.deletedScheduler !== null) {
            let schedulers = [...this.state.schedulers.slice(0, this.state.deletedScheduler), ...this.state.schedulers.slice(this.state.deletedScheduler + 1)];
            this.setState({schedulers: schedulers, showDelete: false, deletedScheduler: null});
            this.props.onUpdateScheduler(this.props.token, schedulers)
        }
    };

    handleEditSchedulerName = (e) => {
        this.setState({editedScheduler: {...this.state.editedScheduler, name: e.target.value}})
    };

    handleEditSchedulerTimezone = (e) => {
        this.setState({editedScheduler: {...this.state.editedScheduler, timeZone: e.target.value}})
    };

    show15minutes = () => {

        this.setState({show15mins: true});

        document.getElementById('div15minutes').style.display = 'block';
        document.getElementById('div1hour').style.display = 'none';
    };

    show15minutesInit = () => {
        document.getElementById('div15minutes').style.display = 'block';
        document.getElementById('div1hour').style.display = 'none';
    };

    show1hour = () => {

        this.setState({show15mins: false});

        document.getElementById('div15minutes').style.display = 'none';
        document.getElementById('div1hour').style.display = 'block';
    };

    show1hourInit = () => {
        document.getElementById('div15minutes').style.display = 'none';
        document.getElementById('div1hour').style.display = 'block';
    };

    show15minutesedit = () => {
        if (this.state.editedScheduler.granularity === '15min') {
            this.setState({editedScheduler: {...this.state.editedScheduler, schedulers: this.state.schedulers[this.state.editedSchedulerId].schedulers}, show15mins: true})
        } else {
            let s = {...this.state.editedScheduler};
            s.schedulers = null;
            this.setState({show15mins: true, editedScheduler: s});
        }
        document.getElementById('div15minutesedit').style.display = 'block';
        document.getElementById('div1houredit').style.display = 'none';
    };

    show15minuteseditInit = () => {
        document.getElementById('div15minutesedit').style.display ='block';
        document.getElementById('div1houredit').style.display ='none';
    };

    show1houredit = () => {
        if (this.state.editedScheduler.granularity === 'hour') {
            this.setState({editedScheduler: {...this.state.editedScheduler, schedulers: this.state.schedulers[this.state.editedSchedulerId].schedulers}, show15mins: false})
        } else {
            let s = {...this.state.editedScheduler};
            s.schedulers = null;
            this.setState({show15mins: false, editedScheduler: s})
        }
        document.getElementById('div15minutesedit').style.display = 'none';
        document.getElementById('div1houredit').style.display = 'block';
    };


    show1houreditInit = () => {
        document.getElementById('div15minutesedit').style.display = 'none';
        document.getElementById('div1houredit').style.display = 'block';
    };

    render() {
        return (
            <div>

                <div className="wrapper">
                    <Loader fullPage={true} loading={this.props.loading}/>
                    <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                        <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                            className="navbar-toggler-icon"></span></button>
                        <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                             href="http://example.com" id="dropdown10"
                                                                             data-toggle="dropdown" aria-haspopup="true"
                                                                             aria-expanded="false">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                              alt="" title=""/></div>
                            </div>
                            {this.props.company}</a>
                            <div className="dropdown-menu" aria-labelledby="dropdown10">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handlerLogout}>Logout</a></div>
                        </div>
                    </div>
                    <div className="sidebar offcanvas-collapse">
                        <div className="sidebar-wrapper">
                            <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                                className="simple-text dropdown-toggle"
                                                                                data-toggle="collapse"
                                                                                data-target="#dropdown11">
                                <div className="company-logo">
                                    <div className="inner-logo rounded-circle img-thumbnail"><img
                                        src={maleAvatar} alt="" title=""/></div>
                                </div>
                                {this.props.company} </a>
                                <div className="dropdown-menu collapse" id="dropdown11">
                                    <a className="dropdown-item" href="#">{this.props.company}</a>
                                    <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                                </div>
                            </div>
                            <ul className="nav">
                                {
                                    this.props.gcpOnly ? null :
                                        (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                            <p>AWS Dashboard</p>
                                        </a></li>)
                                }
                                {
                                    this.props.hasGcp ?
                                        (
                                            <li><a href="#" onClick={this.redirectToGcpDashboard}> <i className="fa fa-bar-chart"></i>
                                                <p>GCP Dashboard</p>
                                            </a></li>
                                        ) : null
                                }

                                <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                    src={computerIcon} alt="" title=""/></i>
                                    <p>Xogroups</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToBudget}> <i className="fa fa-dollar"></i>
                                    <p>Budgets</p>
                                </a></li>
                                <li className="active"><a href="#"> <i className="fa fa-calendar"></i>
                                    <p>Schedules</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToAlerts}> <i className="com-icon"><img
                                    src={alertsIcon} alt="" title="" width="25"/></i>
                                    <p>Alerts</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToInstallation}> <i className="fa fa-wrench"></i>
                                    <p>Installation</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToSettings}> <i className="fa fa-gear"></i>
                                    <p>Settings</p>
                                </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-panel">
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">Schedules</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <button type="button" className="btn btn-secondary" disabled={this.isReadOnly()}
                                                                    onClick={e => this.handleAddScheduler(e)}
                                                                    data-toggle="modal" data-target="#addSchedule">Add
                                                                Schedule
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Schedule Name</th>
                                                        <th className="text-center">Edit</th>
                                                        <th className="text-center">Delete</th>
                                                        <th className="text-center">Copy</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.schedulers.map((s, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td data-title="Schedule Name">{s.name}</td>
                                                                <td data-title="Edit" align="center" width="80"><a
                                                                    href="#"
                                                                    onClick={e => this.handleEditScheduler(e, index)}
                                                                    className="text-primary"
                                                                    data-toggle="modal"
                                                                    data-target="#editSchedule"><i
                                                                    className="fa fa-edit fa-x"></i></a></td>
                                                                <td data-title="Delete" align="center" width="80"><a
                                                                    href="#"
                                                                    onClick={e => {if (this.isReadOnly()) {return false;} else {this.handleDeleteScheduler(e, index)}}}
                                                                    className="text-danger"
                                                                    data-toggle="modal"
                                                                    data-target="#deleteitem"><i
                                                                    className="fa fa-trash-o fa-x"></i></a></td>
                                                                <td data-title="Copy" align="center" width="80"><a
                                                                    href="#"
                                                                    onClick={e =>  {if (this.isReadOnly()) {return false;} else {this.handleCopyScheduler(e, index)}}}
                                                                    className="text-primary"><i
                                                                    className="fa fa-copy fa-x"></i></a></td>
                                                            </tr>
                                                        )
                                                    })}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.addScheduler} toggle={this.toggleAddScheduler} size="exl">
                    <ModalHeader toggle={this.toggleAddScheduler}><strong>Add Scheduler</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-11 col-md-12">
                                    <div className="form-group row no-gutters">
                                        <div className="col-lg-3 col-md-6">
                                            <label className="mt-2">Name:</label>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <input type="text" className="form-control" onChange={e => this.handleEditSchedulerName(e)}/>
                                        </div>
                                    </div>
                                    <div className="form-group row no-gutters">
                                        <div className="col-lg-3 col-md-6">
                                            <label className="mt-2">Time Zone:</label>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <select onChange={e => this.handleEditSchedulerTimezone(e)}>
                                                <option>Select...</option>
                                                {
                                                    timezones.map((t, idx) => {
                                                        return <option key={idx} value={t.value}>{t.label}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row mt-4">
                                        <div className="col-lg-3 col-md-6">
                                            <label>Schedule interval:</label>
                                        </div>
                                        <div className="col-lg-9 col-md-6">
                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="custom-control custom-radio">
                                                        <input type="radio" id="15minutes" name="ScheduleResolution"
                                                               className="custom-control-input"
                                                               onClick={() => this.show15minutes()}  defaultChecked={false}></input>
                                                            <label className="custom-control-label" htmlFor="15minutes">15
                                                                minutes</label>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="custom-control custom-radio">
                                                        <input type="radio" id="1hour" name="ScheduleResolution" defaultChecked={true}
                                                               className="custom-control-input" onClick={() => this.show1hour()}></input>
                                                            <label className="custom-control-label" htmlFor="1hour">1
                                                                hour</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="div15minutes" className="mt-2 flip-scroll" style={{display:'block'}}>
                                        <table width="100%" cellPadding="0" cellSpacing="0"
                                               className="table schedule-table minutes">
                                            <thead>
                                            <tr>
                                                <th className="text-center small text-nowrap bg-white black"><strong>Hours<span
                                                    className="hide-flip-table"> ></span></strong></th>
                                                <th className="text-center">00</th>
                                                <th className="text-center">01</th>
                                                <th className="text-center">02</th>
                                                <th className="text-center">03</th>
                                                <th className="text-center">04</th>
                                                <th className="text-center">05</th>
                                                <th className="text-center">06</th>
                                                <th className="text-center">07</th>
                                                <th className="text-center">08</th>
                                                <th className="text-center">09</th>
                                                <th className="text-center">10</th>
                                                <th className="text-center">11</th>
                                                <th className="text-center">12</th>
                                                <th className="text-center">13</th>
                                                <th className="text-center">14</th>
                                                <th className="text-center">15</th>
                                                <th className="text-center">16</th>
                                                <th className="text-center">17</th>
                                                <th className="text-center">18</th>
                                                <th className="text-center">19</th>
                                                <th className="text-center">20</th>
                                                <th className="text-center">21</th>
                                                <th className="text-center">22</th>
                                                <th className="text-center">23</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">UN</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">M<span
                                                    className="hide-flip-table">ON</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">UE</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">W<span
                                                    className="hide-flip-table">ED</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">HU</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">F<span
                                                    className="hide-flip-table">RI</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">AT</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                            <div className="data-status schedule-available"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div id="div1hour" className="mt-2 flip-scroll">
                                        <table width="100%" cellPadding="0" cellSpacing="0"
                                               className="table schedule-table">
                                            <thead>
                                            <tr>
                                                <th className="text-center small text-nowrap bg-white black"><strong>Hours<span
                                                    className="hide-flip-table"> ></span></strong></th>
                                                <th className="text-center">00</th>
                                                <th className="text-center">01</th>
                                                <th className="text-center">02</th>
                                                <th className="text-center">03</th>
                                                <th className="text-center">04</th>
                                                <th className="text-center">05</th>
                                                <th className="text-center">06</th>
                                                <th className="text-center">07</th>
                                                <th className="text-center">08</th>
                                                <th className="text-center">09</th>
                                                <th className="text-center">10</th>
                                                <th className="text-center">11</th>
                                                <th className="text-center">12</th>
                                                <th className="text-center">13</th>
                                                <th className="text-center">14</th>
                                                <th className="text-center">15</th>
                                                <th className="text-center">16</th>
                                                <th className="text-center">17</th>
                                                <th className="text-center">18</th>
                                                <th className="text-center">19</th>
                                                <th className="text-center">20</th>
                                                <th className="text-center">21</th>
                                                <th className="text-center">22</th>
                                                <th className="text-center">23</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">UN</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">M<span
                                                    className="hide-flip-table">ON</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">UE</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">W<span
                                                    className="hide-flip-table">ED</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">HU</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">F<span
                                                    className="hide-flip-table">RI</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">AT</span></td>
                                                {[...Array(24)].map((_, i) => {
                                                    return (
                                                        <td key={i}>
                                                            <div className="data-status"></div>
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary" onClick={e => this.handleAddSchedulerSubmit(e)}>Add Schedule</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.editScheduler} toggle={this.toggleEditScheduler} size="exl">
                    <ModalHeader toggle={this.toggleEditScheduler}><strong>Edit Scheduler</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-11 col-md-12">
                                    <div className="form-group row no-gutters">
                                        <div className="col-lg-3 col-md-6">
                                            <label className="mt-2">Name:</label>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <input type="text" className="form-control" value={this.state.editedScheduler ? this.state.editedScheduler.name : ''} disabled={this.isReadOnly()} onChange={e => this.handleEditSchedulerName(e)}/>
                                        </div>
                                    </div>
                                    <div className="form-group row no-gutters">
                                        <div className="col-lg-3 col-md-6">
                                            <label className="mt-2">Time Zone:</label>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <select value={this.state.editedScheduler ? this.state.editedScheduler.timeZone : ''} disabled={this.isReadOnly()} onChange={e => this.handleEditSchedulerTimezone(e)}>
                                                <option value=''>Select...</option>
                                                {
                                                    timezones.map((t, idx) => {
                                                        return <option key={idx} value={t.value}>{t.label}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row mt-4">
                                        <div className="col-lg-3 col-md-6">
                                            <label>Schedule interval:</label>
                                        </div>
                                        <div className="col-lg-9 col-md-6">
                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="custom-control custom-radio">
                                                        <input type="radio" id="15minutesedit" disabled={this.isReadOnly()}
                                                               name="ScheduleResolutionedit"
                                                               className="custom-control-input"
                                                               onClick={() => this.show15minutesedit()} checked={this.state.show15mins}></input>
                                                            <label className="custom-control-label"
                                                                   htmlFor="15minutesedit">15 minutes</label>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="custom-control custom-radio">
                                                        <input type="radio" id="1houredit" name="ScheduleResolutionedit" disabled={this.isReadOnly()}
                                                               className="custom-control-input"
                                                               onClick={() => this.show1houredit()} checked={!this.state.show15mins}></input>
                                                            <label className="custom-control-label" htmlFor="1houredit">1
                                                                hour</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="div15minutesedit" className="hide mt-2 flip-scroll" style={{display:"block"}}>
                                        <table width="100%" cellPadding="0" cellSpacing="0"
                                               className="table schedule-table minutes">
                                            <thead>
                                            <tr>
                                                <th className="text-center small text-nowrap bg-white black"><strong>Hours<span
                                                    className="hide-flip-table"> ></span></strong></th>
                                                <th className="text-center">00</th>
                                                <th className="text-center">01</th>
                                                <th className="text-center">02</th>
                                                <th className="text-center">03</th>
                                                <th className="text-center">04</th>
                                                <th className="text-center">05</th>
                                                <th className="text-center">06</th>
                                                <th className="text-center">07</th>
                                                <th className="text-center">08</th>
                                                <th className="text-center">09</th>
                                                <th className="text-center">10</th>
                                                <th className="text-center">11</th>
                                                <th className="text-center">12</th>
                                                <th className="text-center">13</th>
                                                <th className="text-center">14</th>
                                                <th className="text-center">15</th>
                                                <th className="text-center">16</th>
                                                <th className="text-center">17</th>
                                                <th className="text-center">18</th>
                                                <th className="text-center">19</th>
                                                <th className="text-center">20</th>
                                                <th className="text-center">21</th>
                                                <th className="text-center">22</th>
                                                <th className="text-center">23</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">UN</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                               this.state.editedScheduler.schedulers[0].map((dd, idx) => {
                                                        return (<td key={idx}>
                                                            {
                                                                dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                            }
                                                        </td>)

                                                })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">M<span
                                                    className="hide-flip-table">ON</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[1].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i}
                                                                                          className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">UE</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[2].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">W<span
                                                    className="hide-flip-table">ED</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[3].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">HU</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[4].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">F<span
                                                    className="hide-flip-table">RI</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[5].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">AT</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || !this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                    <div className="data-status schedule-available"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[6].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status schedule-available" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>

                                            </tbody>
                                        </table>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div id="div1houredit" className="mt-2 flip-scroll">
                                        <table width="100%" cellPadding="0" cellSpacing="0"
                                               className="table schedule-table">
                                            <thead>
                                            <tr>
                                                <th className="text-center small text-nowrap bg-white black"><strong>Hours<span
                                                    className="hide-flip-table"> ></span></strong></th>
                                                <th className="text-center">00</th>
                                                <th className="text-center">01</th>
                                                <th className="text-center">02</th>
                                                <th className="text-center">03</th>
                                                <th className="text-center">04</th>
                                                <th className="text-center">05</th>
                                                <th className="text-center">06</th>
                                                <th className="text-center">07</th>
                                                <th className="text-center">08</th>
                                                <th className="text-center">09</th>
                                                <th className="text-center">10</th>
                                                <th className="text-center">11</th>
                                                <th className="text-center">12</th>
                                                <th className="text-center">13</th>
                                                <th className="text-center">14</th>
                                                <th className="text-center">15</th>
                                                <th className="text-center">16</th>
                                                <th className="text-center">17</th>
                                                <th className="text-center">18</th>
                                                <th className="text-center">19</th>
                                                <th className="text-center">20</th>
                                                <th className="text-center">21</th>
                                                <th className="text-center">22</th>
                                                <th className="text-center">23</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">UN</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) : this.state.editedScheduler.schedulers[0].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">M<span
                                                    className="hide-flip-table">ON</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[1].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">UE</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[2].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">W<span
                                                    className="hide-flip-table">ED</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[3].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">T<span
                                                    className="hide-flip-table">HU</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[4].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">F<span
                                                    className="hide-flip-table">RI</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[5].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>
                                            <tr>
                                                <td className="schedule-day">S<span
                                                    className="hide-flip-table">AT</span></td>
                                                {
                                                    (!this.state.editedScheduler || !this.state.editedScheduler.schedulers || this.state.show15mins) ?
                                                        [...Array(24)].map((_, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <div className="data-status"></div>
                                                                </td>
                                                            )
                                                        }) :
                                                        this.state.editedScheduler.schedulers[6].map((dd, idx) => {
                                                            return (<td key={idx}>
                                                                {
                                                                    dd.map((d, i) => <div key={i} className={(d.status === 'on') ? "data-status" : "data-status schedule-booked"}></div>)
                                                                }
                                                            </td>)

                                                        })
                                                }
                                            </tr>

                                            </tbody>
                                        </table>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary" disabled={this.isReadOnly()} onClick={e => this.handleEditSchedulerSubmit(e)}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.showDelete} toggle={this.toggleShowDelete} size="lg">
                    <ModalBody>
                        <ModalBody>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12 text-center"><i
                                        className="fa fa-warning fa-3x text-warning mt-4"></i>
                                        <h5 className="mt-4 mb-4">Are you sure you want to delete this item?</h5>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <button type="button" className="btn btn-light" data-dismiss="modal"
                                    aria-label="Close" onClick={this.handleCancelDelete}>Cancel
                            </button>
                            <input type="submit" value="Delete" className="btn btn-primary"
                                   onClick={e => this.handleDelete(e)}></input>
                        </ModalFooter>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.settings.token || state.login.token,
        loading: state.scheduler.loading,
        error: state.scheduler.error,
        company: state.login.company,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        schedulers: state.scheduler.schedulers,
        permissions: state.login.permissions,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchSchedulers: token => dispatch(actions.fetchSchedulers(token)),
        onUpdateScheduler: (token, schedulers) => dispatch(actions.editSchedulers(token, schedulers)),
        onCopyScheduler: (token, name) => dispatch(actions.copyScheduler(token, name)),
        onLogout: (token) => dispatch(actions.logout(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Scheduler)